<template>
  <div class="card">
    <div class="card-body" ref="searchBox">
      <div class="d-flex with-button">
        <div class="p-2">
          <h1>메뉴 관리</h1>
        </div>
        <div class="p-2 small bottom">
          총 <strong><span class="number mint">{{tableData.length}}</span></strong> 건
        </div>

        <div class="ml-auto p-2">
          <button type="button" class="btn mint" @click="goEdit('NEW')">+ 새 메뉴 추가</button>
        </div>

      </div>

      <div class="d-flex">
        <div class="p-2 w-100">
          <div class="input-group search">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control" aria-describedby="basic-addon1" v-model="search.menu_name" @keyup.enter="retrieve" placeholder="메뉴명">
            <div class="input-group-apend">
              <button type="button" class="btn btn-default" @click="retrieve">
                 검색
              </button>
            </div>
          </div>
        </div>
        <div class="p-2 search-detail" v-if="searchDetailVisible">
          <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
        </div>
      </div>

    </div>
    <!-- 그리드 -->
    <stone-data-table
      :loading="searchLoading"
      :columns="tableColumns"
      :data="tableData"
      :table-props="tableProps"
      :page-size="emptyPageSize"
      :pagination-props="emptyPaginationProps"
      :action-col="actionCol"
      @row-click="rowClickHandler">
    </stone-data-table>

  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M990101',
  mixins: [common.mixins],
  data () {
    return {
      tableData: [],
      tableColumns: [
        {label: '메뉴코드', prop: 'menu_code', align: 'left', class: 'bold', width: 100},
        {label: '메뉴명', prop: 'menu_name', align: 'left', width: 150},
        {label: '화면명', prop: 'menu_link', align: 'center', width: 100},
        {label: '메뉴 유형', prop: 'menu_type_name', align: 'center', width: 100},
        {label: '상위 메뉴', prop: 'parent_name', width: 100},
        {label: '클래스명', prop: 'class_name', align: 'left', width: 150},
        {label: '정렬', prop: 'ordby', align: 'right', width: 60}
      ],
      currentPage: 0,
      paginationProps: {},
      tableProps: {height: this.getScreenHeight(-50)},
      actionCol: {
        label: '삭제',
        props: {
          align: 'center'
        },
        buttons: [{
          handler: row => {
            this.deleteMenu(row.menu_code, row.parent_code)
          },
          props: {
            type: 'danger',
            size: 'mini'
          },
          label: '삭제'
        }]
      },
      search: {
        menu_name: ''
      }
    }
  },
  beforeCreate () {
  },
  created () {
    if (this.$route.params.isSearch) {
      this.$parent.$parent.$parent.getMenuAuth()
    }
    this.retrieve()
  },
  mounted () {
  },
  methods: {
    retrieve () {
      this.loadStoneDataTable('/menu/list', this.search)
        .then(response => {
          this.tableData = response.data
        })
    },
    goEdit (menuCode) {
      const param = {
        menu_code: menuCode
      }
      this.$router.push({name: 'M990102', params: param})
    },
    rowClickHandler (row, event, column) {
      this.goEdit(row.menu_code)
    },
    deleteMenu (menuCode, parentCode) {
      this.$confirm('삭제하시겠습니까?', '', {
      }).then(() => {
        let param = {}
        param.menu_code = menuCode
        param.parent_code = parentCode
        common.axios.delete('/menu', {data: param})
          .then(response => {
            this.$message('삭제되었습니다.')
            this.$parent.$parent.getMenuAuth()
            this.retrieve()
          })
          .catch(() => {
            this.$message.error('삭제 실패하였습니다. 관리자에게 문의하세요')
          })
      }).catch(() => {
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/M990101.vue